module.exports = __webpack_public_path__ + "static/media/6.293d12bb.jpg";